import { useContext } from 'react';
import { DrawerContext } from 'new/components/drawer/Drawer';

export function useDrawerContext() {
  return useContext(DrawerContext);
}
